'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/yearsAgo.js
// module id = 613
// module chunks = 0